<!-- Close button only visible in fullscreen mode -->
<button class="btn btn-close" aria-label="Close" (click)="exitFullscreen()">
  <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
</button>

<div class="actions">
  <button class="btn btn-default" (click)="enterFullscreen()" *ngIf="isFullscreenAvailable">
    <i>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#384347" width="16" height="16" viewBox="0 0 26 26">
        <title>fullscreen</title>
        <path
          d="M14.016 5.016h4.969v4.969h-1.969v-3h-3v-1.969zM17.016 17.016v-3h1.969v4.969h-4.969v-1.969h3zM5.016 9.984v-4.969h4.969v1.969h-3v3h-1.969zM6.984 14.016v3h3v1.969h-4.969v-4.969h1.969z"
        ></path>
      </svg>
    </i>
    {{ 'FULL_SCREEN' | translate }}
  </button>

  <button class="btn btn-default" (click)="print()">
    <i>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#384347" width="16" height="16" viewBox="0 0 26 26">
        <title>local_printshop</title>
        <path
          d="M18 3v3.984h-12v-3.984h12zM18.984 12q0.422 0 0.727-0.281t0.305-0.703-0.305-0.727-0.727-0.305-0.703 0.305-0.281 0.727 0.281 0.703 0.703 0.281zM15.984 18.984v-4.969h-7.969v4.969h7.969zM18.984 8.016q1.219 0 2.109 0.891t0.891 2.109v6h-3.984v3.984h-12v-3.984h-3.984v-6q0-1.219 0.891-2.109t2.109-0.891h13.969z"
        ></path>
      </svg>
    </i>
    {{ 'PRINT' | translate }}
  </button>

  <button class="btn btn-default" (click)="share()" *ngIf="isSharingAvailable">
    <i>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#384347" width="16" height="16" viewBox="0 0 26 26">
        <title>ios_share</title>
        <path
          d="M15.984 5.016l-1.406 1.406-1.594-1.594v11.156h-1.969v-11.156l-1.594 1.594-1.406-1.406 3.984-4.031zM20.016 9.984v11.016q0 0.844-0.586 1.43t-1.43 0.586h-12q-0.844 0-1.43-0.586t-0.586-1.43v-11.016q0-0.797 0.586-1.383t1.43-0.586h3v1.969h-3v11.016h12v-11.016h-3v-1.969h3q0.844 0 1.43 0.586t0.586 1.383z"
        ></path>
      </svg>
    </i>
    {{ 'SHARE' | translate }}
  </button>
</div>

<div class="print-logo">
  <img class="logo-img" src="/assets/logo_light_bg.png" alt="" />
</div>

<div class="container container-fluid lh-container-fluid-sm" *ngIf="storageLocation">
  <div class="title">{{ storageLocation.name }}</div>
  <div class="subtitle">Luggage storage</div>

  <hr />

  <div class="booking-qr">
    <div class="scan-cta">Scan me!</div>

    <div class="code-wrapper">
      <qrcode
        [qrdata]="directDropoffUrl"
        [width]="160"
        [errorCorrectionLevel]="'Q'"
        [imageSrc]="'/assets/qr-logo.svg'"
        [imageWidth]="48"
        [imageHeight]="48"
        [margin]="1"
        [colorDark]="'#23b8ea'"
        [colorLight]="'#ffffff'"
        *ngIf="directDropoffUrl"
      ></qrcode>

      <div *ngIf="directDropoffShortUrl" class="short-url">{{ directDropoffShortUrl }}</div>

      <div class="explainer">Scan this QR code to make or retrieve a booking on your phone</div>
    </div>
  </div>

  <div class="luggage-image" *ngIf="isLuggageImageExampleEnabled">
    <hr />
    <p>When you take a photo of your luggage, make sure<br />the number of the luggage tag is clearly visible.</p>

    <div class="examples">
      <div class="example-image large">
        <img src="/assets/luggage-image-example-bad.jpg" />
        <span>⛔</span>
      </div>
      <div class="example-image">
        <img src="/assets/luggage-image-example-good.jpg" />
        <span>✅</span>
      </div>
    </div>
  </div>

  <div class="wifi-container" *ngIf="wifiSsid || wifiUsername || wifiPassword">
    <div class="wifi-info" *ngIf="wifiSsid">
      <hr />

      <div class="header">Wi-Fi Info</div>

      <div class="row">
        <div class="col-6">Network Name</div>
        <div class="col-6">{{ wifiSsid }}</div>
      </div>

      <div class="row" *ngIf="wifiUsername">
        <div class="col-6">Username</div>
        <div class="col-6">{{ wifiUsername }}</div>
      </div>

      <div class="row" *ngIf="wifiPassword">
        <div class="col-6">Password</div>
        <div class="col-6">{{ wifiPassword }}</div>
      </div>
    </div>

    <div class="wifi-qr" *ngIf="wifiSsid">
      <qrcode
        [qrdata]="wifiData"
        [width]="60"
        [errorCorrectionLevel]="'M'"
        [imageSrc]="'/assets/qr-wifi-icon.svg'"
        [imageWidth]="16"
        [imageHeight]="16"
        [margin]="0"
      ></qrcode>
    </div>
  </div>

  <div class="footer">
    <hr />
    <div class="footer-section">
      <strong class="footer-item">{{ 'EMAIL' | translate }}</strong>
      <span class="footer-item">contact&#64;luggagehero.com</span>
      <span class="footer-item"> | </span>
      <strong class="footer-item">{{ 'TAB_BAR_CHAT' | translate }}</strong>
      <span class="footer-item">luggagehero.com</span>
    </div>
    <div class="footer-section">
      <span class="luggagehero">LuggageHero ® </span>
      <span>is a registered trademark. All rights reserved.</span>
    </div>
  </div>

  <div class="bottom-padding"></div>
</div>
